import type { EvidenceUploadMode, ModelResults } from 'api';

import { formatEvidenceRejectionReason } from '../formatEvidenceRejectionReason';
import { getAnalysisStatus } from './getAnalysisStatus';

const isImageRejected = (model_results: ModelResults) => {
  return model_results?.outputs?.[0]?.image_rejected;
};

export const getAnalysisStatusAndRejectionReason = (mode: EvidenceUploadMode, model_results?: ModelResults) => {
  if (!model_results) {
    return {
      analysisStatus: 'accepted' as const,
      photoRejectedReason: undefined,
      photoWarningReason: undefined,
    };
  }

  return {
    analysisStatus: model_results?.outputs?.[0]?.image_rejected
      ? 'rejected-photo'
      : getAnalysisStatus(mode, model_results),
    photoRejectedReason: isImageRejected(model_results)
      ? model_results?.outputs?.[0]?.image_rejection_reasons?.map((reason) => formatEvidenceRejectionReason(reason))[0]
      : undefined,
    photoWarningReason: undefined,
  };
};
